export default __webpack_public_path__ + "static/media/dev_ops_img.361e43de.svg";